export default __webpack_public_path__ + "static/media/urban_piper_logo.3346b6c0.svg";